import Text from './text.json'
import AltText from './altText.json'
import { createUseStyles, useTheme } from 'react-jss'
import styles from './style'
import { ExternalAlphormPages } from 'constants/'
import { decorateUrl } from 'components/common/UTMscript'
import { AdCard } from 'UI'

const useStyle = createUseStyles(styles)

export default ({ altText, noMargin, margin, loading, isAlgeria }) => {
  const theme = useTheme()
  const { paperClass } = useStyle({ noMargin, margin })
  const businessUrl = decorateUrl(isAlgeria ? ExternalAlphormPages.AlgerianBusinessOffer : ExternalAlphormPages.BusinessOffer)
  return (
    <AdCard
      loading={loading}
      className={paperClass}
      href={businessUrl}
      title={altText ? AltText.title : Text.title}
      core={altText ? AltText.text : Text.text}
      buttonLabel={altText ? AltText.button : Text.button}
      onButtonClick={() => window.open(businessUrl, '_blank')}
      shadowColor={theme.info[0]}
    />
  )
}
